module.exports = __webpack_public_path__ + "static/media/DayView.a630f6ef.svg";